module.exports = __webpack_public_path__ + "static/media/_azores-islands.621c7b77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_azores-islands.svg
// module id = 2301
// module chunks = 7